import React from 'react'
import { Typography, useTheme } from '@mui/material'
import Link from 'next/link'

type Props = {
  to: string
  style?: React.CSSProperties
}

const ButtonMoreInfos: React.FC<Props> = ({ to, style = {} }) => {
  const theme = useTheme()
  return (
    <Typography>
      <Link
        href={to}
        style={{
          marginLeft: 4,
          marginRight: 4,
          margin: 10,
          width: 138,
          height: 40,
          borderColor: '#213390',
          color: '#213390',
          fontSize: theme.typography.pxToRem(18),
          ...style,
        }}
      >
        Voir tout
      </Link>
    </Typography>
  )
}

export default ButtonMoreInfos
